<template>
  <div class="match">
    <p class="title">海选作品提交：</p>
    <!-- 上传入口 -->
    <div class="input-upload-wrap">
      <div class="order-upload-wrap">
        <div class="order-file-wrap">
         <el-upload class="upload-file" action
            ref="uploadFileFirst"
            :http-request="uploadFile"
            :data="{ objectType: '24', objectTag: '01'}"
            :before-upload="(file, fileList) => {beforeUpload(file, fileList, '01')}"
            :on-remove="(file, fileList) => {handleRemove(file, fileList, '01')}"
            :file-list="designFirstFile"
            :auto-upload="true" :limit="3" multiple>
            <div class="upload-file-dragger1">
              <i class="el-icon-plus"></i>
            </div>
            <span class="describe" v-show="designFirstFile.length<=0">{{user.userType=='10'?'请上传少于15页PDF作品文档':'请上传压缩文件（内含6张参赛作品图片）'}}</span>
          </el-upload>
        </div>
      </div>
    </div>

    <p class="title">复赛作品提交：</p>
    <!-- 上传入口 -->
    <div class="input-upload-wrap">
      <div class="order-upload-wrap">
        <div class="order-file-wrap">
          <el-upload class="upload-file" action
            ref="uploadFileSecond"
            :http-request="uploadFile"
            :data="{ objectType: '24', objectTag: '02'}"
            :before-upload="(file, fileList) => {beforeUpload(file, fileList, '02')}"
            :on-remove="(file, fileList) => {handleRemove(file, fileList, '02')}"
            :file-list="designSecondFile"
            :auto-upload="true" :limit="3" multiple>
            <div class="upload-file-dragger1">
              <i class="el-icon-plus"></i>
            </div>
            <span class="describe" v-show="designSecondFile.length<=0">{{user.userType=='10'?'请上传1分30秒以内的视频':'请上传少于15页PDF作品文档'}}</span>
          </el-upload>
        </div>
      </div>
    </div>

    <p class="title" v-if="user.userType=='10'">决赛作品提交：</p>
    <!-- 上传入口 -->
    <div class="input-upload-wrap" v-if="user.userType=='10'">
      <div class="order-upload-wrap">
        <div class="order-file-wrap">
          <el-upload class="upload-file" action
             ref="uploadFileThird"
            :http-request="uploadFile"
            :data="{ objectType: '24', objectTag: '03'}"
            :before-upload="(file, fileList) => {beforeUpload(file, fileList, '03')}"
            :on-remove="(file, fileList) => {handleRemove(file, fileList, '03')}"
            :file-list="designThirdFile"
            :auto-upload="true" :limit="3" multiple>
            <div class="upload-file-dragger1">
              <i class="el-icon-plus"></i>
            </div>
            <span class="describe" v-show="designThirdFile.length<=0">请上传少于15页PPT</span>
          </el-upload>
        </div>
      </div>
    </div>
    <div class="design-confirm-btn" v-if="showFlag">
      <y-button text="立即提交" classStyle="main-btn ml" @btnClick="submitFile" />
    </div>
  </div>
</template>
<script>
  import Vue from 'vue'
  import {
    uploadByPieces
  } from "../../../common/upload.js";
  import YButton from '/components/YButton';
  import {
    mapState
  } from 'vuex'
  export default ({
    data() {
      return {
        showFlag: true,
        selectFileCount: 0,
        successFileCount: 0,
        designFirstFile: [],
        designSecondFile: [],
        designThirdFile:  [],
        matchDetail: {}
      }
    },
    computed: {
      ...mapState(['user'])
    },
    created() {
      this.loadDataList();
    },
    methods: {
      loadDataList() {
        this.$api.get({
          url: '/biz/match/detail/' + this.user.userId
        }).then(res => {
          if (res.code == 200) {
            this.matchDetail = res.data
          }
        })
      },
      async uploadFile({
        response,
        file,
        data
      }) {
        this.validateFile(file, data.objectTag).then(isUpload => {
          if(isUpload===true) {
            var loading = this.$loading({
              text: '等待上传完成，已上传 0%'
            });
            uploadByPieces({
              file: file, // 文件
              data: data,
              pieceSize: 3, // 分片大小
              concurrent: 3,
              process: res => {
                loading.setText('等待上传完成，已上传' + res + '%')
                // console.log('分片上传 -> process', res)
                // if (res == 100) {
                // loading.close();
                // }
              },
              success: res => {
                var temp = {
                  url: res.data.url,
                  name: file.name
                }
                if (data.objectTag == '01') {
                  this.designFirstFile.push(temp)
                } else if (data.objectTag == '02') {
                  this.designSecondFile.push(temp)
                } else if (data.objectTag == '03') {
                  this.designThirdFile.push(temp)
                }
                this.successFileCount += 1
                if (this.successFileCount == this.selectFileCount) {
                  loading.close();
                  this.selectFileCount = 0;
                  this.successFileCount = 0;
                }
                loading.close();
                // console.log('分片上传 -> success', res)
              },
              error: e => {
                this.selectFileCount = 0
                this.successFileCount = 0
                this.$yxz.msg('网络错误'.e, 'success')
                // console.log('分片上传 -> error', e)
              }
            })
          }else {
            this.deleteFailFile(file,data);
          }
        })
      },
      submitFile() {
        let firstArray = [];
        let secondArray = [];
        let thirdArray = [];
        if(this.matchDetail !=null) {
           firstArray = JSON.parse(this.matchDetail.designFirstData);
           secondArray = JSON.parse(this.matchDetail.designSecondData);
           thirdArray = JSON.parse(this.matchDetail.designThirdData);
        }
        var matchData = {
          designFirstData: firstArray.length != 0 ?'': JSON.stringify(this.designFirstFile),
          designSecondData: secondArray.length != 0 ?'': JSON.stringify(this.designSecondFile),
          designThirdData: thirdArray.length != 0 ?'': JSON.stringify(this.designThirdFile),
        }
        console.log('this.matchDetail: ',this.matchDetail);
        console.log('data:',matchData)
        this.$confirm('确定提交以上文件？', '', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          center: true
        }).then(() => {
          this.$api.post({
            url: '/biz/match',
            data: matchData,
          }).then(res => {
            console.log('res',res)
            if (res.code == 200) {
              this.$yxz.msg('上传成功', 'success');
              this.$yxz.to('/home');
              this.showFlag = false;
            } else {
              this.$yxz.msg(res.msg);
            }
          })
        })
      },
      beforeUpload(file, fileList, tag) {
          return new Promise((resolve, reject) => {
            const validationResult = this.validateFile(file, tag);
            if (validationResult === true) {
              resolve(file);
            } else {
              validationResult.then(res=>{
                this.$yxz.msg(res)
              })
              reject(new Error(validationResult));
            }
          });
      },
      async validateFile(file, tag) {
        let firstArray = [];
        let secondArray = [];
        let thirdArray = [];
        console.log('this.matchDetail: ',this.matchDetail);
        if(this.matchDetail !=null) {
           firstArray = JSON.parse(this.matchDetail.designFirstData);
           secondArray = JSON.parse(this.matchDetail.designSecondData);
           thirdArray = JSON.parse(this.matchDetail.designThirdData);
        }
        if (Array.isArray(firstArray) && firstArray.length != 0 && tag=='01') {
          return '海选作品已上传，无需重复上传';
        }
        if (Array.isArray(secondArray) && secondArray.length != 0 && tag=='02') {
          return '复赛作品已上传，无需重复上传';
        }
        if (Array.isArray(thirdArray) && thirdArray.length != 0 && tag=='03') {
          return '决赛已上传，无需重复上传';
        }
        return this.limitUpload (file, tag);
      },
      limitUpload(file,tag){
        const fileType = file.name.substring(file.name.lastIndexOf('.') + 1).toLowerCase();
        const allowedTypesMap = {
          '01': [['pdf'], ['rar', 'zip', '7z']],
          '02': [['mp4'], ['pdf']],
          '03': [['ppt', 'pptx'], []]
        };
        const [personaltype, businessType] = allowedTypesMap[tag] || [[], []];
        if(this.user.userType=='10'&&!personaltype.includes(fileType)){
          return '请上传'+personaltype+'格式类型的文件';
        }else if(this.user.userType=='20'&&!businessType.includes(fileType)){
          return '请上传'+businessType+'格式类型的文件';
        }
        this.selectFileCount += 1
        return true;
      },
      deleteFailFile(file,data) {
        const uploadFileRefs = {
          '01': this.$refs.uploadFileFirst,
          '02': this.$refs.uploadFileSecond,
          '03': this.$refs.uploadFileThird
        };
        if (uploadFileRefs[data.objectTag]) {
          let uid = file.uid;
          let idx = uploadFileRefs[data.objectTag].uploadFiles.findIndex(item => item.uid === uid);
          if (idx !== -1) {
            uploadFileRefs[data.objectTag].uploadFiles.splice(idx, 1);
          }
        }
      },
      handleRemove(file, fileList, type) {
        // let name = ''
        // let tempData = ''
        // if (type == '24') {
        //   name = 'designFileList';
        //   tempData = this.fileList;
        // }
        // if (tempData == '') {
        //   this.$message("数据错误！！")
        //   return false
        // }
        // for (let i = 0; i < tempData.length; i++) {
        //   if (file.name === tempData[i].name) {
        //     tempData.splice(i, 1);
        //   }
        // }
        // this.$message({
        //   type: 'success',
        //   message: '移除成功!'
        // });
      }
    },
    mounted() {
      localStorage.removeItem('matchUpload')
    },
    components: {
      YButton
    }
  })
</script>
<style lang="scss" scoped>
  @import "../../assets/style/mixin";

  .match {
    max-width: 1200px;
    width: 100%;
    height: auto;
    background: white;
    margin: 0 auto;
    color: #00A4D4;
    padding: 20px;
    box-sizing: border-box;
  }

  .title {
    font-size: 20px;
    margin: 40px 0px 0px 70px;
  }

  .input-upload-wrap {
    margin: 0px 0px 0px 60px;
  }

  .order-upload-wrap {
    display: flex;
    flex-direction: column;
    padding: 0 30px;
  }

  .order-file-wrap {
    height: 120px;
    padding: 10px 5px 10px 10px;
    box-sizing: border-box;
    border-radius: 8px;
    border: 2px solid rgba(#00A4D4, .1);
  }

  .order-file-wrap {
    padding: 10px;
    margin: 20px 0;
    position: relative;
  }

  .upload-file {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .upload-file-dragger1 {
    width: 100px;
    height: 100px;
    line-height: 100px;
    border: 1px dashed #c0ccda;
    border-radius: 6px;
    box-sizing: border-box;
    font-size: 28px;
    color: #8c939d;
    margin-right: 80px;

    &:hover {
      border-color: #20a0ff;
    }
  }

  .design-confirm-btn {
    width: 100%;
    text-align: center;
    padding: 10px;
    margin: 60px 0;
  }

  .describe {
    position: absolute;
    top: 45%;
    left: 37%;
    color: #a09c9c;
    border-bottom: 1px solid #a09c9c;
  }
</style>



// WEBPACK FOOTER //
// matchUpload.vue?4254ed0f